import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export function PhoneShell({ children }: Props) {
  return (
    <div className="phone-stage">
      <div className="phone-device" role="presentation">
        <div className="phone-notch" aria-hidden />
        <div className="phone-screen">{children}</div>
        <div className="phone-home-indicator" aria-hidden />
      </div>
    </div>
  );
}
